import { defineComponent as _defineComponent } from 'vue'
import PopupVideo from '@/components/popup-video.vue';
import googleCalendar from '@/util/google-api';
import microsoftCalendar from '@/util/microsoft-graph';
import VLoader from '../loader.vue';
import {ref, onMounted} from 'vue'
import { useCalendars } from '@/store/calendars';
import { computed } from '@vue/reactivity';
type Emits = {
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'calendar-setup',
  emits: ["progress"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */


const loading = ref(false);

const showIntroVideo = ref(true)
const showCalendarVideo = ref(false)

const calendars = computed(() => useCalendars().calendars);

const googleMessage = ref('');
const microsoftMessage = ref('');
const microsoftActive = computed(() => !!useCalendars().calendars.find(cal => cal.type === 'microsoft' && cal.accessToken != ''))
const googleActive = computed(() => !!useCalendars().calendars.find(cal => cal.type === 'google' && cal.accessToken !== ''))

const doLinkGoogle = async () => {
    loading.value = true;
    googleMessage.value = '';
    const tmpWindow = window.open(undefined, "auth popup", "width=400,height=500,left=100,top=100");
    try{
        let result = await googleCalendar.linkGoogle(tmpWindow)
        if(result.success) {
            googleMessage.value = "Successfully linked to Google";
        } else {
            googleMessage.value = result.error;
        }
    }catch(e){
        console.warn("An Error Occurred while linking google")
    }finally{
        loading.value = false;
    }
    // googleCalendar.linkGoogle(tmpWindow).then(result => {
    //     loading.value = false;
    //     if(result.success) {
    //         googleActive.value = true
    //         googleMessage.value = "Successfully linked to Google";
    //     } else {
    //         googleMessage.value = result.error;
    //     }
    // })

}

const doLinkMicrosoft = async () => {
    loading.value = true;
    microsoftMessage.value = '';
    const tmpWindow = window.open(undefined, "auth popup", "width=400,height=500,left=100,top=100");
    try{
        let result = await microsoftCalendar.linkMicrosoft(tmpWindow)
        if(result.success) {
            microsoftMessage.value = "Successfully linked to Google";
        } else {
            microsoftMessage.value = result.error;
        }
    }catch(e){
        console.warn("An Error Occurred while linking microsoft")
    }finally{
        loading.value = false;
    }
    // microsoftCalendar.linkMicrosoft(tmpWindow).then(result => {
    //     loading.value = false;
    //     if(result.success) {
    //         microsoftActive.value = true
    //         microsoftMessage.value = "Successfully linked to Microsoft";
    //     } else {
    //         microsoftMessage.value = result.error;
    //     }
    // })
}


const __returned__ = { emit, loading, showIntroVideo, showCalendarVideo, calendars, googleMessage, microsoftMessage, microsoftActive, googleActive, doLinkGoogle, doLinkMicrosoft, PopupVideo, googleCalendar, microsoftCalendar, VLoader, ref, onMounted, useCalendars, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})